//FireBase
exports.firebaseConfig = {
    apiKey: "AIzaSyDqSJSJ0LEhsQWub6cLFaEhSZ1h-vexe2o",
    authDomain: "unposed-5aadf.firebaseapp.com",
    databaseURL: "https://unposed-5aadf.firebaseio.com",
    projectId: "unposed-5aadf",
    storageBucket: "unposed-5aadf.appspot.com",
    messagingSenderId: "531339834161"
};



//App setup
exports.adminConfig={
  "appName": "Unposed",
  "slogan":"",
  "design":{
    "sidebarBg":"sidebar-1.jpg", //sidebar-1, sidebar-2, sidebar-3
    "dataActiveColor":"rose", //"purple | blue | green | orange | red | rose"
    "dataBackgroundColor":"black", // "white | black"
  },
  "showItemIDs":false,
  "allowedUsers":["ion@me.com"], //If null, allow all users, else it should be array of allowd users
  "allowGoogleAuth":false, //Allowed users must contain list of allowed users in order to use google auth
  "fieldBoxName": "Fields",
  "maxNumberOfTableHeaders":5,
  "prefixForJoin":[""],
  "showSearchInTables":true,
  "methodOfInsertingNewObjects":"push", //timestamp (key+time) | push - use firebase keys
  "goDirectlyInTheInsertedNode":true,
  "urlSeparator":"+",
  "urlSeparatorFirestoreSubArray":"~",
  "googleMapsAPIKey":"YOUR_KEY",

  "fieldsTypes":{
    "photo":["imageUrl","image", "poseUrl"],
    "dateTime":["end","start"],
    "map":["map","latlng","location"],
    "textarea":["description"],
    "html":["content"],
    "radio":["radio","radiotf","sliderIsEnabled"],
    "checkbox":["checkbox"],
    "dropdowns":["poseType","promptType"],
    "file":["video"],
    "rgbaColor":['rgba'],
    "hexColor":['color'],
    "relation":['type','creator'],
    "iconmd":['icon'],
    "iconfa":['iconfa'],
    "iconti":['iconti'],
    "iconio":['iconio'],
  },
  "optionsForDateTime":[
    {"key":"end", "dateFormat":"YYYY-MM-DD" ,"timeFormat":true, "saveAs":"x","locale":"es"},
    {"key":"start", "dateFormat":"X" ,"timeFormat":"HH:mm", "saveAs":"x"},
  ],
  "optionsForSelect":[
      {"key":"dropdowns","options":["new","processing","rejected","completed"]},
      {"key":"checkbox","options":["Skopje","Belgrade","New York"]},
      {"key":"poseType","options":["","standing","walking","sitting","laying"]},
      {"key":"promptType","options":["","romantic","fun"]},
      {"key":"radio","options":["no","maybe","yes"]},
      {"key":"radiotf","options":["true","false"]},
      {"key":"sliderIsEnabled","options":["true","false"]}
  ],
  "optionsForRelation":[
      {
        //Firestore - Native
        "display": "name",
        "isValuePath": true,
        "key": "creator",
        "path": "/users",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "name"
      },
      {
        //Firebase - Mimic function
        "display":"name",
        "key":"eventtype",
        "path":"",
        "isValuePath":false,
        "value":"name",
        "produceRelationKey":true,
        "relationJoiner":"-",
        "relationKey":"type_eventid"
      }
  ],
  "paging":{
    "pageSize": 2000,
    "finite": false,
    "retainLastPage": false
  },
  "hiddenKeys":["keyToHide","anotherKeyToHide","email"],
  "previewOnlyKeys":["previewOnlyKey","anotherPreviewOnlyKye","name"]
}

//Navigation
exports.navigation=[
    {
      "link": "/",
      "name": "Dashboard",
      "schema":null,
      "icon":"home",
      "path": "",
       isIndex:true,
    },
//    {
//      "link": "fireadmin",
//      "path": "posesList",
//      "name": "Poses List",
//      "icon":"list",
//      "tableFields":["imageUrl","title", "description", "instagramId", "photographer", "prompt", "poseType", "promptType"],
//    },
//    {
//    "link": "fireadmin",
//    "path": "suggestedPictures",
//    "name": "Suggested poses",
//    "icon":"list",
//    "tableFields":["poseTitle", "instagramId", "promptSuggestion", "poseDirections", "poseUrl"],
//    },
//    {
//      "link": "push",
//      "path": "",
//      "name": "Push notification",
//      "icon":"speaker_notes",
//      "tableFields":[],
//    }
  ];

  //From v 5.1.0 we suggest remoteSetup due to security
  //
exports.pushSettings={
  "remoteSetup":false,
  "remotePath":"pushSettings",
  "pushType":"firebase", //firebase -  onesignal - expo
  "Firebase_AuthorizationPushKey":"AIzaSyCU_PXBBHS_a6GMVYGpTjiKD4HKEsbqqRk", //Firebase push authorization ket
  "pushTopic":"news", //Only for firebase push
  "oneSignal_REST_API_KEY":"",
  "oneSignal_APP_KEY":"",
  "included_segments":"Active Users", //Only for onesignal push
  "firebasePathToTokens":"/expoPushTokens", //we save expo push tokens in firebase db
  "saveNotificationInFireStore":true, //Should we store the notification in firestore
}

exports.userDetails={

}

exports.remoteSetup=false;
exports.remotePath="admins/mobidonia";
exports.allowSubDomainControl=false;
exports.subDomainControlHolder="admins/";



// WEBPACK FOOTER //
// ./src/config/app.js